"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueFromIv = void 0;
/**
 * Get the value of one of the key/value items
 * you can find in an "{@link https://healthcareinc.atlassian.net/wiki/spaces/REPORTING/pages/107675730/IV+Parameter+structure|IV Parameter}".
 *
 * @param {string} iv - A valid iv parameter string.
 * @param {string} key - The key of the desired value (see above link).
 *
 * @returns {string} The value of the key looked for.
 *
 */
function getValueFromIv(iv, key) {
    if (!iv || !key) {
        return '';
    }
    const ivParams = iv.replace(/(__iv_|vi__)/g, '');
    let value = '';
    const m = ivParams.match(new RegExp(`(${key})_([^_]+)`));
    if (m) {
        value = m[2];
    }
    return value;
}
exports.getValueFromIv = getValueFromIv;
//# sourceMappingURL=get-value-from-iv.js.map